import { html } from "lit-html"
import { virtual, useState } from "haunted"

import { HeaderSection, LocationInfo, DateTimeInfo } from "./components"

import { keyClickWrapper } from "../utils"
import markdown from "../utils/markdown"
import ButtonForm from "../forms/button"
import EventRegButtonForm from "../forms/event-reg"
import { CANCEL_PATH, REGISTER_PATH, STATUSES } from "../constants"

const WorkshopRow = virtual(
  ({
    id,
    name,
    url,
    status,
    description,
    program,
    network,
    date,
    start_time,
    end_time,
    shortened_timezone,
    types,
    remote,
    link,
    location,
    gcal_link,
    can_register,
    can_cancel_registration,
    can_see_checked_in,
    can_edit,
  }) => {
    const [expanded, setExpanded] = useState(false)

    const $filterMount = document.getElementById("filter-mount")
    const iconIcalSrc = $filterMount.dataset.iconIcal
    const iconGoogleCalendarSrc = $filterMount.dataset.iconGoogleCalendar

    const canceled = status === STATUSES.CANCELED
    const inactive = [STATUSES.DRAFT, STATUSES.CANCELED].includes(status)

    return html`
      <div
        class="workshop group filter-result-card ${inactive ? `inactive` : ``}"
      >
        <div
          class="-mx-8 px-8 -my-6 py-6 cursor-pointer"
          role="button"
          tabindex="0"
          @click=${(e) =>
            e?.target.tagName.toLowerCase() === "a"
              ? null
              : setExpanded(!expanded)}
          @keydown=${(e) => keyClickWrapper(e, () => setExpanded(!expanded))}
          aria-controls=${`item-${id}`}
          aria-expanded=${expanded.toString()}
        >
          ${network
            ? html`<p
                class="mb-5 text-sm text-green-active font-bold uppercase"
              >
                Network-wide
              </p>`
            : ""}
          ${HeaderSection({
            status,
            tags: types,
            url,
            can_edit,
            can_share: true,
            iconIcalSrc,
            iconGoogleCalendarSrc,
            gcal_link,
          })}
          <p
            class="title mb-5 text-lg text-blue group-hover:text-black font-bold"
          >
            ${name}
          </p>
          <div class="flex flex-wrap leading-loose">
            ${LocationInfo({ location, link, remote, canceled })}
            ${DateTimeInfo({
              date,
              start_time,
              end_time,
              shortened_timezone,
              canceled,
              program,
            })}
          </div>
        </div>
        <div
          class="collapse-row"
          id=${`item-${id}`}
          aria-hidden=${(!expanded).toString()}
        >
          ${expanded
            ? html`<div class="mt-5 border-t-px border-gray-border pt-5">
                ${remote && link
                  ? html`<p class="mb-5">
                      <i class="far fa-link-simple w-7"></i>
                      <a class="ml-2" href="${link}" target="_blank">
                        Remote event link
                      </a>
                    </p>`
                  : ``}
                ${description
                  ? markdown(description)
                  : html`<p class="italic">No description available</p>`}
                <div
                  class="mt-6 flex flex-row-reverse flex-wrap items-center justify-between"
                >
                  <div class="flex items-center">
                    <a href=${url} class="button secondary grow-0">
                      Workshop details
                    </a>
                    ${can_register
                      ? EventRegButtonForm({
                          action: `${url}${REGISTER_PATH}`,
                          title: "Register",
                          className: "primary ml-4 grow-0",
                        })
                      : ``}
                    ${can_cancel_registration
                      ? ButtonForm({
                          url: `${url}${CANCEL_PATH}`,
                          label: "Cancel registration",
                          buttonClass: "button tertiary ml-4 grow-0",
                        })
                      : ``}
                  </div>
                  ${can_cancel_registration
                    ? html`<p class="text-green-600">&check; Registered</p>`
                    : ``}
                  ${can_see_checked_in
                    ? html`<p class="text-green-600">&check; Checked in</p>`
                    : ``}
                </div>
              </div>`
            : ``}
        </div>
      </div>
    `
  }
)

export default WorkshopRow
